module.exports = __webpack_public_path__ + "static/media/LAVAPRO-BOLD.f45001a4.TTF";